import { render, staticRenderFns } from "./Hygiene.vue?vue&type=template&id=727c6dde&scoped=true&"
import script from "./Hygiene.vue?vue&type=script&lang=js&"
export * from "./Hygiene.vue?vue&type=script&lang=js&"
import style0 from "./Hygiene.vue?vue&type=style&index=0&id=727c6dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c6dde",
  null
  
)

export default component.exports